// removed by extract-text-webpack-plugin
module.exports = {"masthead":"styles__masthead__qV8Ln","step":"styles__step__ihoZl","howToGrid":"styles__howToGrid__z3wBY","howToItem":"styles__howToItem__3ehsy","featureImage":"styles__featureImage__DYlfy","twoStep":"styles__twoStep__n9GPn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Delete/styles.scss
// module id = 906
// module chunks = 0